import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=e060175c&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=ts"
export * from "./ProductDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=e060175c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e060175c",
  null
  
)

export default component.exports